import {useState, useCallback} from 'react';

const STORAGE_KEY = 'jama_restaurant_onboarding';

const initialFormData = {
    // Paso 1: Identidad
    name: '',
    description: '',
    // Paso 2: Imagen
    photo: null,
    photo_error: null,
    // Paso 2: Categoría
    category_id: null,
    subcategory_id: null,
    // Paso 3: Contacto
    contact_email: '',
    mobile: '',
    phone: '',
    estimated_time: '',
    // Paso 4: Ciudad
    city_id: null,
    city_lat: null,
    city_lng: null,
    city_meeting_area: null,
    city_operating_hours: null,
    city_min_hours: null,
    out_of_range: false,
    // Paso 5: Dirección
    address_main: '',
    address_cross: '',
    address_ref: '',
    address: '',
    latitude: '',
    longitude: '',
    // Paso 6: Banco
    bank_id: null,
    bank_account_type: null,
    bank_account_number: '',
    bank_owner_name: '',
    bank_ci_type: 'CI',
    bank_ci_number: '',
    // Paso 8: Plan de pago
    exclusive: null,
    // Paso 9: Facturación
    is_billing_enabled: true,
    business_name: '',
    ruc: '',
    billing_address: '',
    representative_name: '',
    representative_last_name: '',
    representative_dni: '',
    // Paso 8: Horario
    schedule: '',
    // Paso 8: Certificado RUC
    ruc_certificate: null,
    // Paso 11: Términos
    terms_accepted: false,
    // Estado de la solicitud
    restaurantId: null,
};

export const useRestaurantOnboardingForm = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) return {...initialFormData, ...JSON.parse(saved)};
        } catch {
            // ignore
        }
        return initialFormData;
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const saveProgress = useCallback((data) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch {
            // ignore
        }
    }, []);

    const updateFormData = useCallback((updates) => {
        setFormData((prev) => {
            const newData = {...prev, ...updates};
            saveProgress(newData);
            return newData;
        });
    }, [saveProgress]);

    const nextStep = useCallback(() => {
        setCurrentStep((prev) => prev + 1);
        setError(null);
    }, []);

    const prevStep = useCallback(() => {
        setCurrentStep((prev) => Math.max(0, prev - 1));
        setError(null);
    }, []);

    const resetForm = useCallback(() => {
        setFormData(initialFormData);
        setCurrentStep(0);
        setError(null);
        localStorage.removeItem(STORAGE_KEY);
    }, []);

    const setRestaurantId = useCallback((id) => {
        setFormData((prev) => {
            const newData = {...prev, restaurantId: id};
            saveProgress(newData);
            return newData;
        });
    }, [saveProgress]);

    return {
        currentStep,
        formData,
        isSubmitting,
        error,
        setIsSubmitting,
        setError,
        updateFormData,
        nextStep,
        prevStep,
        resetForm,
        setRestaurantId,
    };
};

export default useRestaurantOnboardingForm;
